(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[221],{

/***/ 1221:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ pages_GalleryDetailPage; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/Row.js
var Row = __webpack_require__(4051);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/Col.js
var Col = __webpack_require__(1555);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(1664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./services/utils/linksBuilder.js
var linksBuilder = __webpack_require__(3372);
// EXTERNAL MODULE: ./services/utils/useNavigateTo.js
var useNavigateTo = __webpack_require__(5334);
// EXTERNAL MODULE: ./services/utils/getArtworkSize.js
var getArtworkSize = __webpack_require__(731);
// EXTERNAL MODULE: ./services/utils/getArtworkTitle.js
var getArtworkTitle = __webpack_require__(194);
// EXTERNAL MODULE: ./services/utils/imageResizer.js
var imageResizer = __webpack_require__(3992);
;// CONCATENATED MODULE: ./services/utils/chunk.js
const chunk = (array, chunkSize)=>{
    const chunks = [];
    for(let i = 0; i < array.length; i += chunkSize){
        chunks.push(array.slice(i, i + chunkSize));
    }
    return chunks;
};

// EXTERNAL MODULE: ./services/utils/formatPrice.js
var formatPrice = __webpack_require__(1479);
// EXTERNAL MODULE: ./features/components/GalleryHeader/index.js
var GalleryHeader = __webpack_require__(1115);
// EXTERNAL MODULE: ./features/components/Layout/Container/index.js
var Container = __webpack_require__(1286);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(4184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./features/components/CustomBanner/CustomBanner.module.css
var CustomBanner_module = __webpack_require__(7150);
var CustomBanner_module_default = /*#__PURE__*/__webpack_require__.n(CustomBanner_module);
;// CONCATENATED MODULE: ./features/components/CustomBanner/index.js






const CustomBanner = (param)=>{
    let { title , subtitle , buttonText , buttonLink , buttonTo , dates , left , image , moreHeight =false  } = param;
    const colClass = left ? moreHeight ? 4 : 6 : 12;
    const isLeft = left ? 12 : 4;
    const flexColumn = left ? "flex-column" : "flex-row";
    const justifyClass = left ? "justify-content-center" : "align-items-end";
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: classnames_default()((CustomBanner_module_default()).bannerBg, "d-flex", "align-items-center", moreHeight ? (CustomBanner_module_default()).moreHeight : ""),
        style: {
            backgroundImage: "url(".concat(image, ")")
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "container-fluid z-1 h-100",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Row/* default */.Z, {
                className: "h-100 align-items-end",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Col/* default */.Z, {
                    xs: 12,
                    lg: colClass,
                    className: classnames_default()((CustomBanner_module_default()).bannerInfo, "d-flex", "align-items-center", flexColumn, justifyClass, "pb-0", "h-50"),
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Row/* default */.Z, {
                            className: classnames_default()("w-100", "align-items-center", "mx-auto", "pb-2", "px-2", "pt-sm-1", "pt-5"),
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                                        className: classnames_default()((CustomBanner_module_default()).white, "d-block", "w-100", "mb-2"),
                                        children: title
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h5", {
                                        className: "text-white font-weight-normal mb-0",
                                        children: subtitle
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: "d-block color-cacaca font-weight-normal mb-2 text-center text-lg-left",
                                        children: dates
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Row/* default */.Z, {
                            className: classnames_default()("w-100", "align-items-center", "mx-auto"),
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Col/* default */.Z, {
                                xs: 12,
                                lg: isLeft,
                                className: "px-2",
                                children: buttonText && buttonLink && buttonTo ? /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                    href: buttonLink,
                                    as: buttonTo,
                                    className: "text-white text-decoration-underline fs-14px",
                                    children: buttonText
                                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "artplacerButtons"
                                })
                            })
                        })
                    ]
                })
            })
        })
    });
};
/* harmony default export */ var components_CustomBanner = (CustomBanner);

// EXTERNAL MODULE: ./features/components/NewsletterGalleries/index.js + 1 modules
var NewsletterGalleries = __webpack_require__(1750);
// EXTERNAL MODULE: ./features/components/Layout/HelmetTitle/index.js
var HelmetTitle = __webpack_require__(6470);
// EXTERNAL MODULE: ./features/components/Layout/Wrapper/index.js
var Wrapper = __webpack_require__(1350);
// EXTERNAL MODULE: ./features/components/Layout/SeoTags/index.js
var SeoTags = __webpack_require__(7182);
// EXTERNAL MODULE: ./features/components/Layout/Image/index.js + 1 modules
var Image = __webpack_require__(6627);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(5697);
;// CONCATENATED MODULE: ./node_modules/react-responsive-masonry/es/Masonry/index.js
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }




var Masonry = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(Masonry, _React$Component);

  function Masonry() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = Masonry.prototype;

  _proto.getColumns = function getColumns() {
    var _this$props = this.props,
        children = _this$props.children,
        columnsCount = _this$props.columnsCount;
    var columns = Array.from({
      length: columnsCount
    }, function () {
      return [];
    });
    react.Children.forEach(children, function (child, index) {
      if (child && react.isValidElement(child)) {
        columns[index % columnsCount].push(child);
      }
    });
    return columns;
  };

  _proto.renderColumns = function renderColumns() {
    var gutter = this.props.gutter;
    return this.getColumns().map(function (column, i) {
      return /*#__PURE__*/react.createElement("div", {
        key: i,
        style: {
          display: "flex",
          flexDirection: "column",
          justifyContent: "flex-start",
          alignContent: "stretch",
          flex: 1,
          width: 0,
          gap: gutter
        }
      }, column.map(function (item) {
        return item;
      }));
    });
  };

  _proto.render = function render() {
    var _this$props2 = this.props,
        gutter = _this$props2.gutter,
        className = _this$props2.className,
        style = _this$props2.style;
    return /*#__PURE__*/react.createElement("div", {
      style: _extends({
        display: "flex",
        flexDirection: "row",
        justifyContent: "center",
        alignContent: "stretch",
        boxSizing: "border-box",
        width: "100%",
        gap: gutter
      }, style),
      className: className
    }, this.renderColumns());
  };

  return Masonry;
}(react.Component);

Masonry.propTypes =  false ? 0 : {};
Masonry.defaultProps = {
  columnsCount: 3,
  gutter: "0",
  className: null,
  style: {}
};
/* harmony default export */ var es_Masonry = (Masonry);
;// CONCATENATED MODULE: ./node_modules/react-responsive-masonry/es/ResponsiveMasonry/index.js


var DEFAULT_COLUMNS_COUNT = 1;

var useHasMounted = function useHasMounted() {
  var _useState = (0,react.useState)(false),
      hasMounted = _useState[0],
      setHasMounted = _useState[1];

  (0,react.useEffect)(function () {
    setHasMounted(true);
  }, []);
  return hasMounted;
};

var useWindowWidth = function useWindowWidth() {
  var hasMounted = useHasMounted();

  var _useState2 = (0,react.useState)(0),
      width = _useState2[0],
      setWidth = _useState2[1];

  var handleResize = (0,react.useCallback)(function () {
    if (!hasMounted) return;
    setWidth(window.innerWidth);
  }, [hasMounted]);
  (0,react.useEffect)(function () {
    if (hasMounted) {
      window.addEventListener("resize", handleResize);
      handleResize();
      return function () {
        return window.removeEventListener("resize", handleResize);
      };
    }
  }, [hasMounted, handleResize]);
  return width;
};

var MasonryResponsive = function MasonryResponsive(_ref) {
  var columnsCountBreakPoints = _ref.columnsCountBreakPoints,
      children = _ref.children,
      className = _ref.className,
      style = _ref.style;
  var windowWidth = useWindowWidth();
  var columnsCount = (0,react.useMemo)(function () {
    var breakPoints = Object.keys(columnsCountBreakPoints).sort(function (a, b) {
      return a - b;
    });
    var count = breakPoints.length > 0 ? columnsCountBreakPoints[breakPoints[0]] : DEFAULT_COLUMNS_COUNT;
    breakPoints.forEach(function (breakPoint) {
      if (breakPoint < windowWidth) {
        count = columnsCountBreakPoints[breakPoint];
      }
    });
    return count;
  }, [windowWidth, columnsCountBreakPoints]);
  return /*#__PURE__*/react.createElement("div", {
    className: className,
    style: style
  }, react.Children.map(children, function (child, index) {
    return react.cloneElement(child, {
      key: index,
      columnsCount: columnsCount
    });
  }));
};

MasonryResponsive.propTypes =  false ? 0 : {};
MasonryResponsive.defaultProps = {
  columnsCountBreakPoints: {
    350: 1,
    750: 2,
    900: 3
  },
  className: null,
  style: null
};
/* harmony default export */ var ResponsiveMasonry = (MasonryResponsive);
;// CONCATENATED MODULE: ./node_modules/react-responsive-masonry/es/index.js


/* harmony default export */ var es = (es_Masonry);

;// CONCATENATED MODULE: ./features/components/DiscoverMasonry/index.js






const DiscoverMasonry = (param)=>{
    let { items  } = param;
    const Item = (param)=>{
        let { title , subtitle , subSubTitle , image , to , href , sold , price  } = param;
        const Card = ()=>/*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "m-2",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* Image */.E, {
                        src: (0,imageResizer/* imageResizer */.J)(image, 800, "AUTO"),
                        alt: title,
                        className: "mb-2"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                                className: "text-black mb-0 font-secondary fw-700 fs-16px",
                                children: title
                            }),
                            subtitle && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: "mb-0 font-secondary text-black fs-14px",
                                children: subtitle
                            }),
                            subSubTitle && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: "mb-0 color-gray-super-light fs-13px font-primary fs-09em",
                                children: subSubTitle
                            }),
                            sold && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: "mb-0 text-black fs-14px font-secondary fw-700",
                                children: "Sold"
                            }),
                            !sold && price && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: "mb-0 text-black fs-14px font-secondary fw-700",
                                children: price
                            })
                        ]
                    })
                ]
            });
        if (to && href) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                href: href,
                as: to,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Card, {})
            });
        }
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Card, {});
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ResponsiveMasonry, {
        columnsCountBreakPoints: {
            350: 1,
            750: 2,
            900: 3,
            1200: 4
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(es, {
            children: items.map((item, i)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(Item, {
                    ...item
                }, item.to || "".concat(item.image, "-").concat(i)))
        })
    });
};

// EXTERNAL MODULE: ./features/components/GalleryContactModal/index.js
var GalleryContactModal = __webpack_require__(7538);
// EXTERNAL MODULE: ./features/components/Layout/Button/index.js
var Button = __webpack_require__(158);
// EXTERNAL MODULE: ./features/actions/useContactAction.js
var useContactAction = __webpack_require__(5419);
;// CONCATENATED MODULE: ./features/pages/GalleryDetailPage/index.js
























const GalleryDetailPage = (param)=>{
    let { galleryDetails  } = param;
    var _galleryDetails_collections;
    const navigateTo = (0,useNavigateTo/* useNavigateTo */.j)();
    const onNavigate = async ()=>{
        await navigateTo("/galleries/".concat(galleryDetails.domain, "/artworks"));
    };
    const { form , setForm , onSubmit , handleShow , handleClose , modal , success , error , errorMessage , onReCAPTCHAChange , recaptchaRef , loading  } = (0,useContactAction/* useContactAction */.J)(galleryDetails);
    const fullOrHalf = galleryDetails.featured_exhibition && galleryDetails.featured_space ? 6 : 12;
    (0,react.useEffect)(()=>{
        ArtPlacer.clear();
        // Not in the onboarding preview: there is no real gallery id there and
        // the page is inert (pointer-events: none).
        galleryDetails.featured_space && !galleryDetails.isPreview && ArtPlacer.insert({
            gallery: galleryDetails.id,
            type: "2",
            text: "View collection",
            space: galleryDetails.featured_space.id,
            classname: "fs-12px tt-u ".concat((CustomBanner_module_default()).button),
            after: ".artplacerButtons"
        });
    }, []);
    const galleryPageURL = "https://discover.artplacer.com/galleries/".concat(galleryDetails.domain);
    // Discover Profile statement; fall back to the Artist Info statement when empty.
    const statement = galleryDetails.discover_statement || galleryDetails.statement;
    const featuredArtworks = galleryDetails.featured_artworks || galleryDetails.artworks || [];
    var _galleryDetails_collections_length;
    const collectionsCount = (_galleryDetails_collections_length = (_galleryDetails_collections = galleryDetails.collections) === null || _galleryDetails_collections === void 0 ? void 0 : _galleryDetails_collections.length) !== null && _galleryDetails_collections_length !== void 0 ? _galleryDetails_collections_length : 0;
    var _galleryDetails_featured_exhibition_thumbnail, _i_label;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Wrapper/* default */.Z, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(SeoTags/* SeoTags */.o, {
                title: "".concat(galleryDetails.name, " | Discover ArtPlacer"),
                description: "Find information and learn more about ".concat(galleryDetails.name, ". See artworks, try them in your \n          room, and get in touch."),
                image: galleryDetails.thumbnail,
                url: galleryPageURL,
                canonical: galleryPageURL
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(HelmetTitle/* HelmetTitle */.i, {
                title: galleryDetails.name
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container/* default */.Z, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(GalleryHeader/* GalleryHeader */.g, {
                        galleryDetails: galleryDetails,
                        onClickContact: handleShow
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Row/* default */.Z, {
                        className: "justify-content-center text-black fs-15px fs-mobile-14px",
                        children: statement && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Col/* default */.Z, {
                                    lg: 8,
                                    md: 8,
                                    sm: 10,
                                    xs: 11,
                                    className: "mb-md-2 mb-sm-0 mt-md-4 mt-sm-1",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        className: "mb-0 word-wrap-break font-weight-light text-black lh-17 ws-pw text-container ".concat(statement.length > 1000 ? "two-columns" : ""),
                                        children: statement
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("hr", {
                                    className: "w-100 mx-3 mt-4 mb-4 pb-0"
                                })
                            ]
                        })
                    }),
                    featuredArtworks.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(Row/* default */.Z, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Col/* default */.Z, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Row/* default */.Z, {
                                    className: "mb-2 align-items-center",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Col/* default */.Z, {
                                            xs: 8,
                                            className: "px-4",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                                className: "text-black mb-1 fw-700 fs-20px",
                                                children: "Featured Artworks"
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Col/* default */.Z, {
                                            xs: 4,
                                            className: "justify-content-end row pl-2 pr-2 pl-md-4",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                                name: "View catalog",
                                                onClick: ()=>onNavigate(),
                                                width: 100
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(DiscoverMasonry, {
                                    items: featuredArtworks.map((artwork)=>{
                                        var _galleryDetails_currency;
                                        return {
                                            // Onboarding preview is non-navigable and demo artworks have no
                                            // real id, so linksBuilder would emit /artworks/undefined-<slug>;
                                            // skip the link entirely.
                                            ...(galleryDetails === null || galleryDetails === void 0 ? void 0 : galleryDetails.isPreview) ? {} : {
                                                to: linksBuilder/* linksBuilder.artworks */.m.artworks(galleryDetails === null || galleryDetails === void 0 ? void 0 : galleryDetails.domain, artwork.id, artwork.title),
                                                href: (galleryDetails === null || galleryDetails === void 0 ? void 0 : galleryDetails.domain) ? "/galleries/[id]/artworks/[artwork]" : "/artworks/[artwork]"
                                            },
                                            title: (0,getArtworkTitle/* getArtworkTitle */.H)(artwork.title),
                                            subtitle: artwork.artistname,
                                            subSubTitle: (0,getArtworkSize/* getArtworkSize */.Y)(artwork.width, artwork.height),
                                            image: artwork.image,
                                            sold: artwork.sold,
                                            price: artwork.price ? (galleryDetails === null || galleryDetails === void 0 ? void 0 : (_galleryDetails_currency = galleryDetails.currency) === null || _galleryDetails_currency === void 0 ? void 0 : _galleryDetails_currency.symbol) + " " + (0,formatPrice/* formatPrice */.T)(artwork.price) : null
                                        };
                                    })
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Row/* default */.Z, {
                        children: [
                            galleryDetails.featured_space && /*#__PURE__*/ (0,jsx_runtime.jsx)(Col/* default */.Z, {
                                xs: 12,
                                md: fullOrHalf,
                                className: "mb-0 mt-4",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_CustomBanner, {
                                    title: "Check out our most popular collection in a sample room",
                                    buttonText: "View Collection",
                                    // The real button is injected by the widget (skipped on the
                                    // preview); render the static link variant there instead.
                                    buttonLink: galleryDetails.isPreview ? "#" : undefined,
                                    buttonTo: galleryDetails.isPreview ? "#" : undefined,
                                    left: true,
                                    image: (0,imageResizer/* imageResizer */.J)(galleryDetails.featured_space.image, 1920, "AUTO"),
                                    moreHeight: fullOrHalf == 12
                                })
                            }),
                            galleryDetails.featured_exhibition && /*#__PURE__*/ (0,jsx_runtime.jsx)(Col/* default */.Z, {
                                xs: 12,
                                md: fullOrHalf,
                                className: "mb-0 mt-4",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_CustomBanner, {
                                    title: galleryDetails.featured_exhibition.title,
                                    subtitle: galleryDetails.featured_exhibition.author,
                                    buttonText: "Visit exhibition",
                                    buttonTo: "/exhibitions/".concat(galleryDetails.featured_exhibition.id),
                                    buttonLink: "/exhibitions/[id]",
                                    left: true,
                                    image: (0,imageResizer/* imageResizer */.J)((_galleryDetails_featured_exhibition_thumbnail = galleryDetails.featured_exhibition.thumbnail) !== null && _galleryDetails_featured_exhibition_thumbnail !== void 0 ? _galleryDetails_featured_exhibition_thumbnail : galleryDetails.featured_exhibition.image, 1920, "AUTO"),
                                    moreHeight: fullOrHalf == 12
                                })
                            })
                        ]
                    }),
                    galleryDetails && /*#__PURE__*/ (0,jsx_runtime.jsx)(NewsletterGalleries/* default */.Z, {
                        gallery: galleryDetails
                    }),
                    !galleryDetails.isPreview && collectionsCount > 0 && collectionsCount < 80 && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Row/* default */.Z, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("hr", {
                                        className: "w-100 mx-3 mt-4 mb-4 pb-0"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Col/* default */.Z, {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                            className: "text-black mb-3 mt-0 fw-700 fs-20px",
                                            style: {
                                                marginTop: 32
                                            },
                                            children: "Collections"
                                        })
                                    })
                                ]
                            }),
                            chunk(galleryDetails.collections, 6).map((c)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(Row/* default */.Z, {
                                    children: c.map((i)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(Col/* default */.Z, {
                                            sm: "6",
                                            md: "2",
                                            className: "font-weight-light mb-3 fs-15px",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                style: {
                                                    color: "black",
                                                    lineHeight: "1.2",
                                                    whiteSpace: "pre"
                                                },
                                                href: linksBuilder/* linksBuilder.collections */.m.collections(galleryDetails.domain, i.collection),
                                                children: (_i_label = i.label) !== null && _i_label !== void 0 ? _i_label : i.collection
                                            })
                                        }))
                                }))
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(GalleryContactModal/* GalleryContactModal */.X, {
                        form: form,
                        setForm: setForm,
                        galleryDetails: galleryDetails,
                        modal: modal,
                        onSubmit: onSubmit,
                        handleClose: handleClose,
                        error: error,
                        errorMessage: errorMessage,
                        success: success,
                        recaptchaRef: recaptchaRef,
                        onReCAPTCHAChange: onReCAPTCHAChange
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var pages_GalleryDetailPage = (GalleryDetailPage);


/***/ }),

/***/ 7150:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"bannerBg":"CustomBanner_bannerBg__gpjVJ","imgFooter":"CustomBanner_imgFooter__nP3ll","bannerInfo":"CustomBanner_bannerInfo__fgKO_","white":"CustomBanner_white__SNwnG","button":"CustomBanner_button__h6A59","moreHeight":"CustomBanner_moreHeight__eU3O9"};

/***/ })

}]);